import { ref, watch } from 'vue';

const dark = ref(
    localStorage.getItem('theme') === 'dark' ||
    (!localStorage.getItem('theme') && window.matchMedia('(prefers-color-scheme: dark)').matches)
);

function applyTheme(isDark) {
    document.documentElement.classList.toggle('dark', isDark);
    localStorage.setItem('theme', isDark ? 'dark' : 'light');
}

applyTheme(dark.value);

watch(dark, applyTheme);

export function useDarkMode() {
    function toggle() { dark.value = !dark.value; }
    return { dark, toggle };
}
